import { apiFetch } from '@/api'
import { Reason } from '@/interfaces'

export const fetchAllReasons = async (): Promise<Reason> => (await apiFetch('/reasons', { method: 'GET' })).data
